<script>
  import ResourceList from "../components/ResourceList.svelte";
  import { Head, Body, Row, Cell } from "@smui/data-table";
  import { navigate } from "svelte-routing";

  export let location;
  export let title;
  let records;
  title = "Vendors";

  function edit(id) {
    navigate(`${location.pathname}/${id}`);
  }
</script>

<ResourceList resource="vendors" {location} bind:records>
  <Head>
    <Row>
      <Cell>Name</Cell>
      <Cell>Address</Cell>
    </Row>
  </Head>
  <Body>
    {#if records}
      {#each records as row}
        <Row on:click={() => edit(row.id)} class="pointer mdc-data-table__row">
          <Cell>{row.vendor_name}</Cell>
          <Cell>
            {#if row.address}
              {row.address.address_line_1}, {row.address.post_code}
            {/if}
          </Cell>
        </Row>
      {/each}
    {/if}
  </Body>
</ResourceList>
